<template lang="pug">
modal-component(
  title='Vincular Técnicos'
  width='620px'
  @close='$emit("close")'
)
  #modal-vinculacao-tecnico-validacao
    .filtro-container
      text-input-component(
        v-model='filtroNome'
        label=''
        placeholder='Filtrar por nome...'
      )

    .lista-tecnicos-container(v-loading='isLoading')
      p.aviso-vazio(v-if='!isLoading && tecnicosFiltrados.length === 0') Nenhum técnico encontrado.
      .lista-tecnicos
        .tecnico-item(
          v-for='tecnico in tecnicosFiltrados'
          :key='tecnico.id'
        )
          el-checkbox(
            :value='isSelected(tecnico)'
            @change='toggleTecnico(tecnico)'
          ) {{ tecnico.nomeTecnico }}

    p.erro-validacao(v-if='erroTecnicos') {{ erroTecnicos }}

    .modal-footer
      button-component(
        label='Cancelar'
        icon='mdi-close'
        backgroundColor='var(--primary-gray)'
        color='var(--primary-light-smoke)'
        @click.native='$emit("close")'
      )
      button-component(
        label='Vincular'
        icon='mdi-link-variant'
        :disabled='isLoading'
        @click.native='vincular'
      )
</template>

<script>
import { buscarTecnicosParaVinculacao } from '@/services/monitoramento.service';

export default {
  name: 'ModalVinculacaoTecnicoValidacao',

  props: {
    tecnicosSelecionados: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isLoading: false,
      filtroNome: '',
      todosTecnicos: [],
      selecionados: [],
      erroTecnicos: '',
    };
  },

  computed: {
    tecnicosFiltrados() {
      const filtro = this.filtroNome.trim().toLowerCase();
      if (!filtro) return this.todosTecnicos;
      return this.todosTecnicos.filter(t =>
        t.nomeTecnico && t.nomeTecnico.toLowerCase().includes(filtro)
      );
    },
  },

  async mounted() {
    this.isLoading = true;
    try {
      const lista = await buscarTecnicosParaVinculacao();
      this.todosTecnicos = lista.sort((a, b) =>
        (a.nomeTecnico || '').localeCompare(b.nomeTecnico || '', 'pt-BR')
      );
      this.selecionados = this.todosTecnicos.filter(t =>
        this.tecnicosSelecionados.some(s => s.id === t.id)
      );
    } catch (e) {
      this.$notify({ title: 'Erro', message: 'Erro ao carregar técnicos.', type: 'error' });
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    isSelected(tecnico) {
      return this.selecionados.some(s => s.id === tecnico.id);
    },

    toggleTecnico(tecnico) {
      const idx = this.selecionados.findIndex(s => s.id === tecnico.id);
      if (idx > -1) {
        this.selecionados.splice(idx, 1);
      } else {
        this.selecionados.push(tecnico);
      }
      this.erroTecnicos = '';
    },

    vincular() {
      if (this.selecionados.length === 0) {
        this.erroTecnicos = 'É necessário ao menos um técnico para adicionar ao processo!';
        return;
      }
      this.$emit('vincular', [...this.selecionados]);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
#modal-vinculacao-tecnico-validacao {
  padding: 16px;
  min-width: 560px;
}

.filtro-container {
  margin-bottom: 12px;
}

.lista-tecnicos-container {
  max-height: 340px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 8px;
}

.lista-tecnicos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px 16px;
}

.tecnico-item {
  display: flex;
  align-items: center;
}

.aviso-vazio {
  text-align: center;
  color: #999;
  padding: 16px 0;
}

.erro-validacao {
  color: #f56c6c;
  font-size: 12px;
  margin: 4px 0 8px;
}

.modal-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
}
</style>
